/**
 * sonidos — un tono propio por tipo de aviso (WebAudio, sin archivos) para cuando la app está abierta.
 * Con la app cerrada o en segundo plano suena el sonido del sistema (lo decide el service worker + el teléfono).
 *   asignacion: dos notas ascendentes · mencion: ping corto · urgente: tres pulsos graves · cliente: campanita
 *   coberturas: dos notas parejas · avance / resumen: un toque suave
 */
const NOTAS = {
  asignacion: [[660, 0, 0.12], [880, 0.14, 0.18]],
  mencion:    [[1040, 0, 0.14]],
  urgente:    [[440, 0, 0.16], [440, 0.22, 0.16], [440, 0.44, 0.22]],
  cliente:    [[988, 0, 0.1], [1319, 0.12, 0.26]],
  coberturas: [[784, 0, 0.12], [784, 0.16, 0.16]],
  avance:     [[600, 0, 0.1]],
  resumen:    [[520, 0, 0.1]],
};

let ctx = null;

export function sonarAviso(categoria, { volumen = 0.16 } = {}) {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    for (const [freq, ini, dur] of NOTAS[categoria] || NOTAS.avance) {
      const osc = ctx.createOscillator(), g = ctx.createGain();
      osc.type = categoria === "urgente" ? "square" : "sine";
      osc.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t0 + ini);
      g.gain.exponentialRampToValueAtTime(volumen, t0 + ini + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + ini + dur);
      osc.connect(g).connect(ctx.destination);
      osc.start(t0 + ini); osc.stop(t0 + ini + dur + 0.05);
    }
  } catch { /* sin audio: el aviso visual alcanza */ }
}
